import { percentageFormatter } from "helpers/formatters/numbers"

export default [
  {
    id: "identifier",
    name: "Identifier",
  },
  {
    id: "lotId",
    name: "Lot id",
  },
  {
    id: "tagCategory",
    name: "Tag category",
  },
  {
    id: "from",
    name: "From",
  },
  {
    id: "to",
    name: "To",
  },
  {
    id: "maxGMV",
    name: "Max % GMV",
    formatter: (value) => percentageFormatter(value / 100),
    numeric: true,
  },
  {
    id: "counts",
    name: "Counts",
    numeric: true,
  },
]
